import { loadTheme } from '@progress/kendo-diagram-common';

(function() {
    const kendo = window.kendo;
    const dataviz = kendo.dataviz;

    dataviz.diagramTheme = loadTheme;
})();
